import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import ApiConfig from 'src/config/api-config';
import { sessionStore } from 'src/store/sessionStore';

export interface DuplicateProgramPlanPayload {
  docPath?: string;
  programId?: string;
}

export const useDuplicateProgramPlan = () => {
  const queryClient = useQueryClient();
  const currentUser = sessionStore((s) => s.currentUser);

  return useMutation({
    mutationFn: async (payload: DuplicateProgramPlanPayload) => {
      const trainerId = currentUser?.uid;
      if (!trainerId) throw new Error('Trainer ID not found');

      const response = await fetch(
        `${ApiConfig.CLOUD_FUNCTIONS_BASE_URL}${ApiConfig.TRAINER_DUPLICATE_PROGRAM_PLAN}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ data: { ...payload, trainerId } }),
        },
      );

      if (!response.ok) {
        throw new Error('Failed to duplicate program');
      }

      return response.json();
    },
    onSuccess: () => {
      toast.success('Program duplicated successfully.');
      queryClient.invalidateQueries({ queryKey: ['trainer-program-plan-list'] });
    },
    onError: (error) => {
      console.error(error);
      toast.error('Failed to duplicate the program. Please try again.');
    },
  });
};
